$(document).ready(function () {
    if ($(".slick-buehne").length > 0) {
        $(".slick-buehne").each(function () {
            let slider = $(this);
            slider.slick({
                lazyLoad: 'ondemand',
                dots: false,
                arrows: true,
                fade: true,
                autoplay: true,
                speed: 1500,
                slidesToShow: 1,
                centerMode: false,
                slidesToScroll: 1,
                appendArrows: slider.parent().find('.slick-arrows'),
                prevArrow: '<div class="slide-arrow prev-arrow"><i class="fa-thin fa-chevron-left"></i></div>',
                nextArrow: '<div class="slide-arrow next-arrow"><i class="fa-thin fa-chevron-right"></i></div>',
                appendDots: slider.parent().find('.slick-dots-inner'),
                autoplaySpeed: 4000
            });

            slider.find('.bttn-prev').click(function(){
                slider.slick('slickPrev');

            });
            slider.find('.bttn-next').click(function(){
                slider.slick('slickNext');
            });

            slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

                var CurrentSlideDom=$(slick.$slides.get(currentSlide));
                var NextSlideDom=$(slick.$slides.get(nextSlide));

                NextSlideDom.find('source').each(function () {
                    console.log($(this));
                    $(this).attr('srcset', $(this).data('lazy'));
                });

                // setTimeout(function () {
                //     nextSlideEl.find('.title').addClass('aos-animate')
                //     nextSlideEl.find('.subtitle').addClass('aos-animate')
                // }, 700)
                //

            });
        });
    }
});
